
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { OrganizationWithRelations } from "@/types/organization.types";

interface SocialMediaCardProps {
  organization: OrganizationWithRelations;
}

export function SocialMediaCard({ organization }: SocialMediaCardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Social Media</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {organization.social_instagram && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground">Instagram:</span>
            <a
              href={`https://instagram.com/${organization.social_instagram.replace('@', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-blue-500 hover:text-blue-700"
            >
              {organization.social_instagram}
            </a>
          </div>
        )}
        
        {organization.social_facebook && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground">Facebook:</span>
            <a
              href={`https://facebook.com/${organization.social_facebook}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-blue-500 hover:text-blue-700"
            >
              {organization.social_facebook}
            </a>
          </div>
        )}
        
        {organization.social_linkedin && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground">LinkedIn:</span>
            <a
              href={`https://linkedin.com/company/${organization.social_linkedin}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-blue-500 hover:text-blue-700"
            >
              {organization.social_linkedin}
            </a>
          </div>
        )}
        
        {organization.social_tiktok && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground">TikTok:</span>
            <a
              href={`https://tiktok.com/@${organization.social_tiktok.replace('@', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-blue-500 hover:text-blue-700"
            >
              {organization.social_tiktok}
            </a>
          </div>
        )}
        
        {!organization.social_instagram && !organization.social_facebook && 
         !organization.social_linkedin && !organization.social_tiktok && (
          <div className="text-sm text-muted-foreground italic">
            No social media profiles added
          </div>
        )}
      </CardContent>
    </Card>
  );
}
